class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.message = this.querySelector('[data-cart-notification-message]');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.updateMessage(parsedState);

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;

      const target = document.getElementById(section.id);
      if (!target) return;

      target.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  updateMessage(parsedState) {
    if (!this.message) return;

    const itemsAdded = parsedState.itemsAdded || parsedState.items?.length || parsedState.quantity || 1;
    const count = Number.parseInt(itemsAdded, 10);

    if (count > 1 && this.dataset.messageMultiple) {
      this.message.textContent = this.dataset.messageMultiple.replace('__COUNT__', count);
      this.notification.setAttribute('aria-label', this.message.textContent);
      return;
    }

    this.message.textContent = this.dataset.messageSingle || this.message.textContent;
    this.notification.setAttribute('aria-label', this.message.textContent);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
